import { cn } from "@/utils/cn";
import { IonCheckbox } from "@ionic/react";
import { FormikHelpers } from "formik";

interface LabelCheckboxProps<Values, Value, T> {
  label: string;
  description?: string;
  name: string;
  value: Value;
  setFieldValue?: FormikHelpers<Values>["setFieldValue"];
  onChanged?: (checked: boolean) => void;
  checked?: boolean;
  isMultiple?: boolean;
  values?: Record<string, T>;
}

export const LabelCheckbox = <Values, Value, T>({
  label,
  description,
  name,
  value,
  setFieldValue,
  onChanged,
  checked,
  isMultiple,
  values,
}: LabelCheckboxProps<Values, Value, T>) => {
  const isChecked = checked ?? getIsChecked();

  function getIsChecked() {
    const currentValues = values?.[name];
    if (isMultiple && currentValues instanceof Array) {
      return currentValues.includes(value);
    }
    return currentValues === value;
  }

  const onChecked = (checked: boolean) => {
    const currentValues = values?.[name];
    if (checked) {
      if (isMultiple && currentValues instanceof Array) {
        const newValues = [...currentValues, value];
        console.log("newValues", newValues);
        setFieldValue?.(name, newValues);
      } else {
        setFieldValue?.(name, value);
      }
    } else {
      if (isMultiple && currentValues instanceof Array) {
        const newValues = (currentValues ?? []).filter((v) => v !== value);
        console.log("newValues", newValues);
        setFieldValue?.(name, newValues);
      } else {
        setFieldValue?.(name, null);
      }
    }
  };

  return (
    <div
      onClick={() => {
        if (onChanged) {
          onChanged(!isChecked);
        } else {
          onChecked(!isChecked);
        }
      }}
      className={cn(
        "flex flex-col gap-4 text-sm font-medium rounded-xl p-4 w-full cursor-pointer",
        {
          "bg-secondary-light": isChecked,
          "bg-gray-50": !isChecked,
          "justify-center": !description,
          "justify-between": description,
        },
      )}
    >
      <div className="flex gap-2 justify-between">
        <span className="text-md font-medium">{label}</span>
        <IonCheckbox
          name={name}
          value={value}
          checked={isChecked}
          className="z-1"
          // onIonChange={(e) => {
          //   console.log("e", e.detail.checked);

          //   onChecked(e.detail.checked);
          // }}
        />
      </div>
      {description && (
        <span className="text-gray-500 text-xs mr-12">{description}</span>
      )}
    </div>
  );
};
